import {BaseResponseDTO} from "./base.response.dto";
import {SucursalDTO} from "../sucursal.dto";


export class GetListaSucursalesResponseDTO extends BaseResponseDTO {

  success: boolean;
  msg: string;
  data: Array<SucursalDTO>;

}
